const docsRoutes = [
  {
    path: '/docs',
    name: 'Documentation',
    meta: { authRequired: true },
    children: [
      {
        path: 'introduction',
        name: 'Introduction',
        component: () => import('@/modules/konrixTheme/views/docs/introduction.vue'),
      },
      {
        path: 'installation',
        name: 'Installation',
        component: () => import('@/modules/konrixTheme/views/docs/installation.vue'),
      },
      {
        path: 'customization',
        name: 'Customization',
        component: () => import('@/modules/konrixTheme/views/docs/customization.vue'),
      },
      {
        path: 'changelog',
        name: 'Change Log',
        component: () => import('@/modules/konrixTheme/views/docs/changelog.vue'),
      },
    ],
  },
]

const authRoutes = [
  {
    path: '/login',
    name: 'Login',
    component: () => import('@/modules/konrixTheme/views/auth-pages/login.vue'),
  },
  {
    path: '/register',
    name: 'Register',
    component: () => import('@/modules/konrixTheme/views/auth-pages/register.vue'),
  },
  {
    path: '/recoverpw',
    name: 'Recover Password',
    component: () => import('@/modules/konrixTheme/views/auth-pages/recover-pass.vue'),
  },
  {
    path: '/reset-password',
    name: 'Reset Password',
    component: () => import('@/modules/konrixTheme/views/auth-pages/reset-password.vue'),
  },
  {
    path: '/lock-screen',
    name: 'Lock Screen',
    component: () => import('@/modules/konrixTheme/views/auth-pages/lock-screen.vue'),
  },
  {
    path: '/auth/callback',
    name: 'AuthCallback',
    component: () => import('@/modules/auth/views/AuthCallback.vue'),
  },
]

const errorPageRoutes = [
  {
    path: '/404',
    name: 'Error 404',
    component: () => import('@/modules/konrixTheme/views/pages/error-404.vue'),
  },
  {
    path: '/404-alt',
    name: 'Error 404 Alt',
    component: () => import('@/modules/konrixTheme/views/pages/error-404-alt.vue'),
  },
  {
    path: '/500',
    name: 'Error 500',
    component: () => import('@/modules/konrixTheme/views/pages/error-500.vue'),
  },
  {
    path: '/:catchAll(.*)',
    redirect: '404',
  },
]

const dashboardRoutes = [
  {
    path: '',
    name: 'dashboard',
    meta: {
      authRequired: true,
      title: 'sidebar.dashboard',
      icon: 'mgc_home_line',
      showInMenu: true,
      group: 'main'
    },
    component: () => import('@/modules/dashboard/views/DashboardView.vue'),
  },
  {
    path: '/data/products',
    name: 'products',
    meta: {
      authRequired: true,
      title: 'sidebar.products',
      icon: 'mgc_shopping_cart_1_line',
      showInMenu: true,
      group: 'data'
    },
    component: () => import('@/modules/data/views/ProductView.vue'),
  },
  {
    path: '/data/content',
    name: 'content',
    meta: {
      authRequired: true,
      title: 'sidebar.content',
      icon: 'mgc_book_6_line',
      showInMenu: true,
      group: 'data'
    },
    component: () => import('@/modules/data/views/ContentView.vue'),
  },

  {
    path: '/chat/preview',
    name: 'chat.preview',
    meta: {
      authRequired: true,
      title: 'sidebar.preview',
      icon: 'mgc_chat_1_line',
      showInMenu: true,
      group: 'chat'
    },
    component: () => import('@/modules/chat/views/PreviewView.vue'),
  },
  {
    path: '/chat/chat-interface',
    name: 'chat.chat-interface',
    meta: {
      authRequired: true,
      title: 'sidebar.chatInterface',
      icon: 'mgc_settings_6_line',
      showInMenu: true,
      group: 'chat'
    },
    component: () => import('@/modules/chat/views/ChatInterfaceView.vue'),
  },
  {
    path: '/chat/data-sources',
    name: 'chat.data-sources',
    meta: {
      authRequired: true,
      title: 'sidebar.dataSources',
      icon: 'mgc_layers_line',
      showInMenu: true,
      group: 'chat'
    },
    children: [
      {
        path: 'website',
        name: 'chat.data-sources.from-website',
        meta: {
          authRequired: true,
          title: 'sidebar.dataSourcesWebsite',
          showInMenu: true,
          group: 'chat'
        },
        component: () => import('@/modules/chat/views/DataSource/WebsiteView.vue'),
      },
      {
        path: 'files',
        name: 'chat.data-sources.from-files',
        meta: {
          authRequired: true,
          title: 'sidebar.dataSourcesFiles',
          showInMenu: true,
          group: 'chat'
        },
        component: () => import('@/modules/chat/views/DataSource/FileView.vue'),
      },
      {
        path: 'text',
        name: 'chat.data-sources.from-text',
        meta: {
          authRequired: true,
          title: 'sidebar.dataSourcesText',
          showInMenu: true,
          group: 'chat'
        },
        component: () => import('@/modules/chat/views/DataSource/TextView.vue'),
      },
      {
        path: 'faq',
        name: 'chat.data-sources.from-faq',
        meta: {
          authRequired: true,
          title: 'sidebar.dataSourcesFaq',
          showInMenu: true,
          group: 'chat'
        },
        component: () => import('@/modules/chat/views/DataSource/FaqView.vue'),
      },
      {
        path: 'external',
        name: 'chat.data-sources.from-external',
        meta: { 
          authRequired: true,
          title: 'sidebar.dataSourcesExternal',
          showInMenu: true,
          group: 'chat'
        },
        component: () => import('@/modules/chat/views/DataSource/ExternalView.vue'),
      }
    ]
  },
  {
    path: '/chat/connections',
    name: 'chat.connections',
    meta: {
      authRequired: true,
      title: 'sidebar.connections',
      icon: 'mgc_webhook_line',
      showInMenu: true,
      group: 'chat'
    },
    children: [
      {
        path: 'website',
        name: 'chat.connections.from-website',
        meta: {
          authRequired: true,
          title: 'sidebar.connectionsWebsite',
          showInMenu: true,
          group: 'chat'
        },
        component: () => import('@/modules/chat/views/ConnectionsWebsiteView.vue'),
      },
      {
        path: 'website',
        name: 'chat.connections.WhatsApp',
        meta: {
          authRequired: true,
          title: 'sidebar.connectionsWhatsapp',
          showInMenu: true,
          group: 'chat'
        },
        component: () => import('@/modules/konrixTheme/views/pages/coming-soon.vue'),
      }
    ]
  },
  {
    path: '/chat/logs',
    name: 'chat.logs',
    meta: {
      authRequired: true,
      title: 'sidebar.chatLogs',
      icon: 'mgc_history_line',
      showInMenu: true,
      group: 'chat'
    },
    component: () => import('@/modules/chat/views/ChatLogView.vue'),
  },
]

const appsRoutes = [
  {
    path: '/apps',
    name: 'Apps',
    meta: { authRequired: true },
    children: [
      {
        path: 'calendar',
        name: 'Calendar',
        component: () => import('@/modules/konrixTheme/views/apps/calendar/index.vue'),
      },
      {
        path: 'tickets',
        name: 'Tickets',
        component: () => import('@/modules/konrixTheme/views/apps/tickets/index.vue'),
      },
      {
        path: 'file-manager',
        name: 'File Manager',
        component: () => import('@/modules/konrixTheme/views/apps/file-manager/index.vue'),
      },
      {
        path: 'kanban',
        name: 'Kanban',
        component: () => import('@/modules/konrixTheme/views/apps/kanban/index.vue'),
      },
      {
        path: 'project',
        name: 'Project',
        children: [
          {
            path: 'list',
            name: 'List',
            component: () => import('@/modules/konrixTheme/views/apps/project/list/index.vue'),
          },
          {
            path: 'detail',
            name: 'Detail',
            component: () => import('@/modules/konrixTheme/views/apps/project/detail/index.vue'),
          },
          {
            path: 'create',
            name: 'Create',
            component: () => import('@/modules/konrixTheme/views/apps/project/create/index.vue'),
          },
        ],
      },
    ],
  },
]

const pagesRoutes = [
  {
    path: '/pages',
    name: 'Pages',
    meta: { authRequired: true },
    children: [
      {
        path: 'starter',
        name: 'Starter',
        component: () => import('@/modules/konrixTheme/views/pages/starter.vue'),
      },
      {
        path: 'timeline',
        name: 'Timeline',
        component: () => import('@/modules/konrixTheme/views/pages/timeline.vue'),
      },
      {
        path: 'invoice',
        name: 'Invoice',
        component: () => import('@/modules/konrixTheme/views/pages/invoice.vue'),
      },
      {
        path: 'gallery',
        name: 'Gallery',
        component: () => import('@/modules/konrixTheme/views/pages/gallery.vue'),
      },
      {
        path: 'faq',
        name: 'FAQ',
        component: () => import('@/modules/konrixTheme/views/pages/faq.vue'),
      },
      {
        path: 'pricing',
        name: 'Pricing',
        component: () => import('@/modules/konrixTheme/views/pages/pricing.vue'),
      },
      {
        path: 'maintenance',
        name: 'Maintenance',
        component: () => import('@/modules/konrixTheme/views/pages/maintenance.vue'),
      },
      {
        path: 'coming-soon',
        name: 'Coming Soon',
        component: () => import('@/modules/konrixTheme/views/pages/coming-soon.vue'),
      },
    ],
  },
]

const layoutRoutes = [
  {
    path: '/layout',
    name: 'Layouts',
    meta: { authRequired: true },
    children: [
      {
        path: 'hovered',
        name: 'Hovered Menu',
        component: () => import('@/modules/konrixTheme/views/layouts/hovered.vue'),
      },
      {
        path: 'icon-view',
        name: 'Icon View Menu',
        component: () => import('@/modules/konrixTheme/views/layouts/icon-view.vue'),
      },
      {
        path: 'compact',
        name: 'Compact Menu',
        component: () => import('@/modules/konrixTheme/views/layouts/compact.vue'),
      },
      {
        path: 'mobile-view',
        name: 'Mobile View Menu',
        component: () => import('@/modules/konrixTheme/views/layouts/mobile-view.vue'),
      },
      {
        path: 'hidden',
        name: 'Hidden Menu',
        component: () => import('@/modules/konrixTheme/views/layouts/hidden.vue'),
      },
    ],
  },
]

const componentsRoutes = [
  {
    path: '/ui',
    name: 'ui',
    meta: { authRequired: true },
    children: [
      {
        path: 'accordions',
        name: 'Accordions',
        component: () => import('@/modules/konrixTheme/views/base-ui/accordions.vue'),
      },
      {
        path: 'alerts',
        name: 'Alerts',
        component: () => import('@/modules/konrixTheme/views/base-ui/alerts.vue'),
      },
      {
        path: 'avatars',
        name: 'Avatars',
        component: () => import('@/modules/konrixTheme/views/base-ui/avatars.vue'),
      },
      {
        path: 'buttons',
        name: 'Buttons',
        component: () => import('@/modules/konrixTheme/views/base-ui/buttons.vue'),
      },
      {
        path: 'badges',
        name: 'Badges',
        component: () => import('@/modules/konrixTheme/views/base-ui/badges.vue'),
      },
      {
        path: 'breadcrumbs',
        name: 'Breadcrumbs',
        component: () => import('@/modules/konrixTheme/views/base-ui/breadcrumb.vue'),
      },
      {
        path: 'cards',
        name: 'Cards',
        component: () => import('@/modules/konrixTheme/views/base-ui/cards.vue'),
      },
      {
        path: 'collapse',
        name: 'Collapse',
        component: () => import('@/modules/konrixTheme/views/base-ui/collapse.vue'),
      },
      {
        path: 'dismissible',
        name: 'Dismissible',
        component: () => import('@/modules/konrixTheme/views/base-ui/dismissible.vue'),
      },
      {
        path: 'dropdowns',
        name: 'Dropdowns',
        component: () => import('@/modules/konrixTheme/views/base-ui/dropdowns.vue'),
      },
      {
        path: 'progress',
        name: 'Progress',
        component: () => import('@/modules/konrixTheme/views/base-ui/progress.vue'),
      },
      {
        path: 'skeleton',
        name: 'skeleton',
        component: () => import('@/modules/konrixTheme/views/base-ui/skeleton.vue'),
      },
      {
        path: 'spinners',
        name: 'Spinners',
        component: () => import('@/modules/konrixTheme/views/base-ui/spinners.vue'),
      },
      {
        path: 'list-group',
        name: 'List Group',
        component: () => import('@/modules/konrixTheme/views/base-ui/list-group.vue'),
      },
      {
        path: 'ratio',
        name: 'Aspect Ratio',
        component: () => import('@/modules/konrixTheme/views/base-ui/ratio.vue'),
      },
      {
        path: 'tabs',
        name: 'Tabs',
        component: () => import('@/modules/konrixTheme/views/base-ui/tabs.vue'),
      },
      {
        path: 'modals',
        name: 'Modals',
        component: () => import('@/modules/konrixTheme/views/base-ui/modals.vue'),
      },
      {
        path: 'offcanvas',
        name: 'Offcanvas',
        component: () => import('@/modules/konrixTheme/views/base-ui/offcanvas.vue'),
      },
      {
        path: 'popovers',
        name: 'Popovers',
        component: () => import('@/modules/konrixTheme/views/base-ui/popovers.vue'),
      },
      {
        path: 'tooltips',
        name: 'Tooltips',
        component: () => import('@/modules/konrixTheme/views/base-ui/tooltips.vue'),
      },
      {
        path: 'typography',
        name: 'Typography',
        component: () => import('@/modules/konrixTheme/views/base-ui/typography.vue'),
      },
    ],
  },
]

const extendedRoutes = [
  {
    path: '/extended',
    name: 'Extended',
    meta: { authRequired: true },
    children: [
      {
        path: 'swiper',
        name: 'Swiper',
        component: () => import('@/modules/konrixTheme/views/extended/swiper.vue'),
      },
      {
        path: 'nestable',
        name: 'Nestable List',
        component: () => import('@/modules/konrixTheme/views/extended/nestable-list.vue'),
      },
      {
        path: 'ratings',
        name: 'Ratings',
        component: () => import('@/modules/konrixTheme/views/extended/ratings.vue'),
      },
      {
        path: 'animation',
        name: 'Animation',
        component: () => import('@/modules/konrixTheme/views/extended/animation.vue'),
      },
      {
        path: 'player',
        name: 'Player',
        component: () => import('@/modules/konrixTheme/views/extended/player.vue'),
      },
      {
        path: 'scrollbar',
        name: 'Scrollbar',
        component: () => import('@/modules/konrixTheme/views/extended/scrollbar.vue'),
      },
      {
        path: 'sweet-alert',
        name: 'Sweet Alert',
        component: () => import('@/modules/konrixTheme/views/extended/sweet-alert.vue'),
      },
      {
        path: 'tour',
        name: 'Tour Page',
        component: () => import('@/modules/konrixTheme/views/extended/tour.vue'),
      },
      {
        path: 'tippy-tooltips',
        name: 'Tippy Tooltip',
        component: () => import('@/modules/konrixTheme/views/extended/tippy-tooltip.vue'),
      },
      {
        path: 'lightbox',
        name: 'Lightbox',
        component: () => import('@/modules/konrixTheme/views/extended/lightbox.vue'),
      },
    ],
  },
]

const formRoutes = [
  {
    path: '/forms',
    name: 'Forms',
    meta: { authRequired: true },
    children: [
      {
        path: 'elements',
        name: 'Form Elements',
        component: () => import('@/modules/konrixTheme/views/forms/form-elements.vue'),
      },
      {
        path: 'select',
        name: 'Form Select',
        component: () => import('@/modules/konrixTheme/views/forms/select.vue'),
      },
      {
        path: 'range',
        name: 'Form Range',
        component: () => import('@/modules/konrixTheme/views/forms/range.vue'),
      },
      {
        path: 'pickers',
        name: 'Form Pickers',
        component: () => import('@/modules/konrixTheme/views/forms/pickers.vue'),
      },
      {
        path: 'masks',
        name: 'Form Masks',
        component: () => import('@/modules/konrixTheme/views/forms/masks.vue'),
      },
      {
        path: 'editor',
        name: 'Form Editors',
        component: () => import('@/modules/konrixTheme/views/forms/editors.vue'),
      },
      {
        path: 'file-uploads',
        name: 'Form File upload',
        component: () => import('@/modules/konrixTheme/views/forms/file-upload.vue'),
      },
      {
        path: 'validation',
        name: 'Form Validation',
        component: () => import('@/modules/konrixTheme/views/forms/validation.vue'),
      },
      {
        path: 'layout',
        name: 'Form Layout',
        component: () => import('@/modules/konrixTheme/views/forms/form-layout.vue'),
      },
    ],
  },
]

const tableRoutes = [
  {
    path: '/tables',
    name: 'Table',
    meta: { authRequired: true },
    children: [
      {
        path: 'basic',
        name: 'Basic Table',
        component: () => import('@/modules/konrixTheme/views/tables/basic-tables.vue'),
      },
      {
        path: 'datatables',
        name: 'Data Tables',
        component: () => import('@/modules/konrixTheme/views/tables/data-tables.vue'),
      },
    ],
  },
]

const iconsRoutes = [
  {
    path: '/icons',
    name: 'Icons',
    meta: { authRequired: true },
    children: [
      {
        path: 'mingcute',
        name: 'Mingcute',
        component: () => import('@/modules/konrixTheme/views/icons/mingcute.vue'),
      },
      {
        path: 'feather',
        name: 'feather',
        component: () => import('@/modules/konrixTheme/views/icons/feather.vue'),
      },
      {
        path: 'material-symbols',
        name: 'material',
        component: () => import('@/modules/konrixTheme/views/icons/material-symbols.vue'),
      },
    ],
  },
]

const chartRoutes = [
  {
    path: '/charts',
    name: 'Charts',
    meta: { authRequired: true },
    component: () => import('@/modules/konrixTheme/views/charts/index.vue'),
  },
]

const mapRoutes = [
  {
    path: '/maps',
    name: 'Maps',
    meta: { authRequired: true },
    children: [
      {
        path: 'vector-maps',
        name: 'Vector Maps',
        component: () => import('@/modules/konrixTheme/views/maps/vector-maps/index.vue'),
      },
      {
        path: 'google-maps',
        name: 'Google Maps',
        component: () => import('@/modules/konrixTheme/views/maps/google-maps/index.vue'),
      },
    ],
  },
]

const inboxRoutes = [
  {
    path: '/inbox/tickets',
    name: 'inbox.tickets',
    meta: {
      authRequired: true,
      title: 'sidebar.tickets',
      icon: 'mgc_ticket_line',
      showInMenu: true,
      group: 'inbox'
    },
    component: () => import('@/modules/inbox/views/TicketsView.vue'),
  },
  {
    path: '/inbox/leads',
    name: 'inbox.leads',
    meta: {
      authRequired: true,
      title: 'sidebar.leads',
      icon: 'mgc_user_3_line',
      showInMenu: true,
      group: 'inbox'
    },
    component: () => import('@/modules/inbox/views/LeadsView.vue'),
  },
  {
    path: '/inbox/email-settings',
    name: 'inbox.emailSettings',
    meta: {
      authRequired: true,
      title: 'sidebar.emailSettings',
      icon: 'mgc_settings_6_line',
      showInMenu: true,
      group: 'inbox'
    },
    component: () => import('@/modules/inbox/views/EmailSettingView.vue'),
  },
]

const analyticsRoutes = [
  {
    path: '/analytics/chats',
    name: 'analytics.chats',
    meta: {
      authRequired: true,
      title: 'sidebar.chats',
      icon: 'mgc_chart_bar_line',
      showInMenu: true,
      group: 'analytics'
    },
    component: () => import('@/modules/analytics/views/ChatsView.vue'),
  },
  {
    path: '/analytics/topics',
    name: 'analytics.topics',
    meta: {
      authRequired: true,
      title: 'sidebar.topics',
      icon: 'mgc_tag_line',
      showInMenu: true,
      group: 'analytics'
    },
    component: () => import('@/modules/analytics/views/TopicsView.vue'),
  },
]

const accountRoutes = [
  {
    path: '/account/profile',
    name: 'account.profile',
    meta: {
      authRequired: true,
      title: 'sidebar.profile',
      icon: 'mgc_user_3_line',
      showInMenu: true,
      group: 'account'
    },
    component: () => import('@/modules/account/views/ProfileView.vue'),
  },
  {
    path: '/account/security',
    name: 'account.security',
    meta: {
      authRequired: true,
      title: 'sidebar.security',
      icon: 'mgc_shield_line',
      showInMenu: true,
      group: 'account'
    },
    component: () => import('@/modules/account/views/SecurityAndAccestView.vue'),
  },
  {
    path: '/account/workspace',
    name: 'account.workspace',
    meta: {
      authRequired: true,
      title: 'sidebar.workspace',
      icon: 'mgc_government_line',
      showInMenu: true,
      group: 'account'
    },
    component: () => import('@/modules/account/views/WorkspaceView.vue'),
  },
  {
    path: '/account/billing',
    name: 'account.billing',
    meta: {
      authRequired: true,
      title: 'sidebar.billing',
      icon: 'mgc_bank_card_line',
      showInMenu: true,
      group: 'account'
    },
    component: () => import('@/modules/account/views/BillingView.vue'),
  },
]

const chatbot = [
  {
    path: '/chatbot/create',
    name: 'chatbot.create',
    meta: {
      authRequired: true,
      title: 'sidebar.createChatbot',
      icon: 'mgc_robot_line',
      showInMenu: false,
      group: 'chat'
    },
    component: () => import('@/modules/chatbot/views/ChatbotView.vue'),
  }
]

export const authProtectedRoutes = [
  ...chatbot,
  ...dashboardRoutes,
  ...appsRoutes,
  ...pagesRoutes,
  ...layoutRoutes,
  ...componentsRoutes,
  ...extendedRoutes,
  ...formRoutes,
  ...tableRoutes,
  ...iconsRoutes,
  ...chartRoutes,
  ...mapRoutes,
  ...inboxRoutes,
  ...analyticsRoutes,
  ...accountRoutes,
]

export const allRoutes = [...docsRoutes, ...authRoutes, ...errorPageRoutes, ...authProtectedRoutes]

